import { getExplain, getParagraphForEdit,getParagraph } from '../../../utils/createRender'

let reverseParseText = (data) => {
    let obj = createRender(data, 0);
    let stem = {};
    let answer = {};
    let explain = '';
    let style = {};
    Object.keys(obj).forEach(v => {
        if (v.indexOf('paragraph') > -1) {
            /*处理段落部分*/
            stem[v] = obj[v];
        } else if (v.indexOf("style") > -1) {
            /*处理段落样式*/
            style = JSON.parse(obj[v]);
        } else if (v.indexOf('answer') > -1) {
            /*处理答案*/
            // 填空题，选择题答案格式不同
            answer[v] = `<p>${obj[v]}</p>`;
            ;
        } else if (v.indexOf('explain') > -1) {
            /*处理解析*/
            explain = obj[v]
        }
    })

    return {
        stem,
        explain,
        style,
        answer
    }
}

let reverseParseTextView = data => {
    let obj = createRender(data, 1);
    let stem = "";
    let explain = "";
    let answer = [];
    Object.keys(obj).forEach(val => {
        if (val.indexOf("paragraph") > -1) {
            // 题干部分
            if (obj[val].indexOf('inner_audio') > -1) {
                let reading = obj[val].match(/<div class="audio-box" style="margin-bottom: 10px"><div class="inner_audio"}><\/div><span>点击读题<\/span><audio class="math_reading" src=".*?"><\/audio><\/div>/g);
                let audio = reading[0] ? reading[0] : ''
                stem = audio + stem + obj[val].replace(audio, '');
            } else {
                stem += obj[val];
            }
        } else if (val.indexOf("explain") > -1) {
            // 解析部分
            explain += obj[val];
        } else if (val.indexOf("answer") > -1) {
            // 答案部分
            answer = obj[val].split(/\=(?!')/g).filter(v => v).map(v =>'='+v);
        }
    })

    let result = {
        stem,
        explain,
        answer,
    };
    return result
}

function createRender(data, showType = 1) {//showType:0 编辑用，1 展示用
    if (!data.stem) {
        return {}
    }
    let render = {};

    // 匹配answer
    let answer = '';
    data.answer && (answer = getAnswer(data.answer));

    // 匹配解析
    let explain = '';
    data.explain && (explain = { explain: getExplain(data.explain) });

    switch (showType) {
        case 0:
            // 匹配 stem
            var { paragraph, style } = getParagraphForEdit(data.stem, 'paragraph','deliverySecond');
            render = Object.assign({}, paragraph, explain, answer, style);
            break;
        case 1:
            // 匹配 stem--
            var { paragraph, style } = getParagraph(data.stem, 'paragraph', 'deliverySecond');
            render = Object.assign({}, paragraph, explain, answer, style);
            break;
        default:
            break;
    }
	
    return render;
}

function getAnswer(str) {
    let answer = {};
    let result = str;
    let pattern = /#{(.+?)}#/g;
    let block = result.match(pattern);
    block && block.forEach(item => {
        let content = item.replace(/\#|\\/g, "");
        let obj = {};
        try {
            obj = JSON.parse(content);
        } catch (error) {
            return ''
        }
        switch (obj.type) {
            case 'latex':
                result = result.replace(item, `<span class='mathquill-embedded-latex'>${obj.content}</span>`);
                break;
            default:
                break;
        }
    });
    let con = result.replace(/frac/g, '\\\\frac');
    JSON.parse(con).forEach(item => {
        answer[`answer_${item.blank_id}`] = item.content;
    });
    return answer;
}



export { reverseParseText, reverseParseTextView }


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/deliverySecond/createRender.js